import React from "react";

import { CategoriesTabsMobilePlaceholderStyled as Styles } from "./CategoriesTabsMobile.styles";
import { CategoriesTabsMobilePlaceholderProps as Props } from "./CategoriesTabsMobile.types";

const CategoriesTabsMobilePlaceholder: React.FC<Props> = props => {
  return (
    <Styles className="CategoriesTabsMobilePlaceholder">
      <div className="CategoriesTabsMobilePlaceholder__item loading-shine" />
      <div className="CategoriesTabsMobilePlaceholder__item loading-shine" />
      <div className="CategoriesTabsMobilePlaceholder__item loading-shine" />
      <div className="CategoriesTabsMobilePlaceholder__item loading-shine" />
      <div className="CategoriesTabsMobilePlaceholder__item loading-shine" />
    </Styles>
  );
};

CategoriesTabsMobilePlaceholder.defaultProps = {};

export default CategoriesTabsMobilePlaceholder;
